import { render, staticRenderFns } from "./ContentPlaceholders.vue?vue&type=template&id=6081fc59&"
import script from "./ContentPlaceholders.vue?vue&type=script&lang=js&"
export * from "./ContentPlaceholders.vue?vue&type=script&lang=js&"
import style0 from "./ContentPlaceholders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports